import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import UIModal from "../UIModal";
import { clx } from "../../../utils/Helpers";
import UIActionModalIcon from "./UIActionModalIcon";
import UIActionModalUserInfo from "./UIActionModalUserInfo";
import UIActionModalActions from "./UIActionModalActions";
import UIActionModalDivider from "./UIActionModalDivider";

import "./UIActionModal.scss";

const UIActionModal = ({
  open,
  title,
  children,
  actions,
  onClose,
  variant,
  iconName,
  showIcon,
  maxWidth,
  PaperProps,
  className,
  ...props
}) => {
  const paperClassName = clx(
    "ui-action-modal",
    className,
    PaperProps?.className,
  );

  return (
    <UIModal
      open={open}
      onClose={onClose}
      showClose={false}
      maxWidth={maxWidth}
      PaperProps={{ ...PaperProps, className: paperClassName }}
      actions={actions}
      {...props}
    >
      {showIcon && (
        <UIActionModalIcon variant={variant} iconName={iconName} />
      )}
      {title && (
        <Typography component="h2" className="ui-action-modal__title">
          {title}
        </Typography>
      )}
      {children}
    </UIModal>
  );
};

UIActionModal.Icon = UIActionModalIcon;
UIActionModal.UserInfo = UIActionModalUserInfo;
UIActionModal.Actions = UIActionModalActions;
UIActionModal.Divider = UIActionModalDivider;


UIActionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.node,
  children: PropTypes.node,
  actions: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["approve", "info", "reject"]),
  iconName: PropTypes.string,
  showIcon: PropTypes.bool,
  maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", false]),
  PaperProps: PropTypes.object,
  className: PropTypes.string,
};

UIActionModal.defaultProps = {
  title: null,
  children: null,
  actions: null,
  onClose: undefined,
  variant: "approve",
  iconName: "alertCircle",
  showIcon: true,
  maxWidth: "sm",
  PaperProps: {},
  className: "",
};

export default UIActionModal;
